export default __webpack_public_path__ + "static/media/colors-110.cd5262dc.png";